const cards = [
  {
    id: 1,
    title: '娱乐圈最新爆料合集',
    desc: '本周最劲爆的明星动态与内幕消息全收录，一条都不错过。',
    tag: '热门',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20collage%20with%20warm%20theatrical%20spotlights%20on%20a%20dark%20stage%20background%2C%20dramatic%20lighting%20in%20coral%20and%20golden%20tones%2C%20editorial%20magazine%20style%2C%20mysterious%20atmosphere%20with%20soft%20shadows%2C%20elegant%20composition&width=800&height=500&seq=card-01-entertainment&orientation=landscape',
  },
  {
    id: 2,
    title: '明星动态追踪专题',
    desc: '实时追踪当红明星最新行程、作品动态与生活日常。',
    tag: '追踪',
    tagColor: 'bg-accent-100 text-accent-800',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20aesthetic%20with%20soft%20focus%20and%20warm%20golden%20bokeh%20lights%2C%20elegant%20fashion%20editorial%20style%2C%20coral%20and%20cream%20color%20palette%2C%20sophisticated%20atmosphere%20with%20subtle%20sparkle%20effects&width=800&height=500&seq=card-02-celebrity&orientation=landscape',
  },
  {
    id: 3,
    title: '热播剧综吐槽大会',
    desc: '热门电视剧与综艺节目的趣味解读、幕后花絮与网友神评论。',
    tag: '剧综',
    tagColor: 'bg-secondary-100 text-secondary-800',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20TV%20screen%20with%20warm%20ambient%20glow%20in%20a%20cozy%20living%20room%20setting%2C%20soft%20lighting%20with%20coral%20and%20teal%20accents%2C%20modern%20home%20entertainment%20aesthetic%2C%20comfortable%20viewing%20atmosphere&width=800&height=500&seq=card-03-tvshow&orientation=landscape',
  },
  {
    id: 4,
    title: '网红圈那些事儿',
    desc: '热门网红动态、争议事件与合作八卦，网红圈一手消息全掌握。',
    tag: '网红',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20aesthetic%20with%20ring%20light%20and%20smartphone%20setup%2C%20warm%20neutral%20backdrop%20with%20soft%20shadows%2C%20modern%20content%20creator%20workspace%2C%20coral%20and%20cream%20tones%2C%20clean%20minimal%20composition&width=800&height=500&seq=card-04-influencer&orientation=landscape',
  },
  {
    id: 5,
    title: '体育圈八卦速递',
    desc: '体育明星场外故事、转会风波与赛事花絮，体育迷的吃瓜专区。',
    tag: '体育',
    tagColor: 'bg-accent-100 text-accent-800',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20floodlights%20and%20warm%20golden%20hour%20lighting%2C%20athletic%20energy%20captured%20in%20editorial%20style%2C%20coral%20sunset%20tones%20blending%20with%20stadium%20lights%2C%20powerful%20composition&width=800&height=500&seq=card-05-sports&orientation=landscape',
  },
  {
    id: 6,
    title: '科技圈大瓜盘点',
    desc: '互联网大厂动态、科技大佬言论与行业爆料，科技圈的吃瓜指南。',
    tag: '科技',
    tagColor: 'bg-secondary-100 text-secondary-800',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20tech%20office%20with%20warm%20ambient%20lighting%20and%20sleek%20modern%20design%2C%20soft%20coral%20accent%20lights%20on%20dark%20surfaces%2C%20digital%20innovation%20aesthetic%2C%20clean%20lines%20and%20geometric%20patterns%2C%20professional%20atmosphere&width=800&height=500&seq=card-06-tech&orientation=landscape',
  },
  {
    id: 7,
    title: '海外吃瓜精选',
    desc: '国际娱乐圈与海外名人的热门话题、争议事件一网打尽。',
    tag: '国际',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=International%20news%20collage%20with%20world%20map%20silhouette%20and%20warm%20ambient%20glow%2C%20global%20communication%20concept%2C%20coral%20and%20golden%20accent%20tones%2C%20editorial%20magazine%20layout%20style%2C%20sophisticated%20cosmopolitan%20atmosphere&width=800&height=500&seq=card-07-international&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">热门推荐</h2>
          <p className="text-foreground-600 text-sm md:text-base">精选最新最热的吃瓜内容，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card) => (
            <article
              key={card.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    if (el.parentElement) el.parentElement.style.display = 'none';
                  }}
                />
                <span className={`absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md text-xs font-medium ${card.tagColor}`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}